export const FOLLOWERS_ON_PROJECT_EXPERIMENT = 'followers-visible-on-project';

export const ATLAS_JIRA_GET_ATLAS_FREE = 'atlas_jira_get_atlas_free';
export const ATLAS_JIRA_SEARCH_JIRA_ISSSUES = 'atlas_jira_search_jira_issues';
export const ROVO_SEARCH_COMPARE_RESULTS_PASS_THROUGH_RATE = 'rovo-search-compare-results-pass-through-rate';

// https://switcheroo.atlassian.com/ui/gates/1705872e-b4eb-4f1d-9c1f-9ac0aca67f3d
export const ENABLE_CREATE_PROJECT_MENU_VISUAL_REFRESH = 'enable_create_project_menu_visual_refresh';

// Nav refresh 'beta' experiments
// https://hello.atlassian.net/wiki/spaces/JNR/pages/3699574590/Rollout+technical+design#Beta
export const NAV_REFRESH_FREE_CUSTOMERS_EXP = 'jira_nav4_beta_free-customers';
export const NAV_REFRESH_NEW_CUSTOMERS_EXP = 'jira_nav4_beta_new-customers';
export const NAV_REFRESH_NEW_CUSTOMERS_X_EXP = 'confluence_jira_nav4_new_customers';

// https://switcheroo.atlassian.com/ui/gates/38c4ae74-29c2-4851-a010-866e2c0725aa/key/metrics_improvements_seq_experiment
export const METRICS_IMPROVEMENTS_SEQ_EXPERIMENT = 'metrics_improvements_seq_experiment';

// GRW-2022: View all apps in home experiment
//https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/grw-2022_view_all_apps_in_home/setup
export const GRW_2022_VIEW_ALL_APPS_IN_HOME = 'grw-2022_view_all_apps_in_home';

// https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/townsquare_starred_feed/setup
export const TOWNSQUARE_STARRED_FEED = 'townsquare_starred_feed';

// https://switcheroo.atlassian.com/ui/gates/816731c0-b271-492e-9136-a8da7318253d/key/townsquare_remove_discover_show_more_experiment
export const SKIP_SHOW_MORE_PROGRESSIVE = 'townsquare_remove_discover_show_more_experiment';

// https://switcheroo.atlassian.com/ui/gates/f0c8695a-3334-4f50-99e2-cecd6570ea6d/key/atlassian_projects_-_native_integration
export const PROJECTS_NATIVE_INTEGRATION_WITH_JIRA = 'atlassian_projects_-_native_integration';

// https://switcheroo.atlassian.com/ui/gates/0aa23ab3-e36d-4b44-8765-93718a2205c1/key/loom_global_apps_nav_recommendation_experiment
// Poster: https://hello.atlassian.net/wiki/spaces/Growth/pages/5427977196/Loom+-+global+apps+nav+recommendation+TWCG-38
export const LOOM_GLOBAL_APPS_NAV_RECOMMENDATION_EXPERIMENT = 'loom_global_apps_nav_recommendation_experiment';

// https://switcheroo.atlassian.com/ui/gates/225bbb2b-ee14-4242-b3af-74794a11b89b/key/rovo_chat_refresh_v1_experiment
export const ROVO_CHAT_REFRESH_V1_EXPERIMENT = 'rovo_chat_refresh_v1_experiment';

export const TEAMS_APP_LANDING_APP_PEOPLE_BUTTON_EXPERIMENT = 'teams_app_landing_app_people_button_experiment';

// https://switcheroo.atlassian.com/ui/gates/451e9377-b129-4541-836e-5da6564bfe4f/key/townsquare_3p_sl-clicked_feed_results_experiment
// Poster: https://hello.atlassian.net/wiki/x/vVP4WQE
export const HOME_FEEDS_3P_SL_CLICKED_EXPERIMENT = 'townsquare_3p_sl-clicked_feed_results_experiment';

// https://switcheroo.atlassian.com/ui/gates/753cc05b-a6e4-4a75-9904-9c62de861e8c/key/team_lens_in_atlassian_home
export const TEAM_LENS_IN_ATLASSIAN_HOME_EXPERIMENT = 'team_lens_in_atlassian_home';

// https://switcheroo.atlassian.com/ui/gates/ff87512f-6ee5-4f44-93d3-cce6647aa4c8/key/teams_directory_uplift
export const PEOPLE_AND_TEAMS_DIRECTORY_UPLIFT_EXPERIMENT = 'teams_directory_uplift';

// Make sure you add your experiment to the list of valid experiments
export const experiments = {
	ATLAS_JIRA_GET_ATLAS_FREE,
	ATLAS_JIRA_SEARCH_JIRA_ISSSUES,
	ENABLE_CREATE_PROJECT_MENU_VISUAL_REFRESH,
	FOLLOWERS_ON_PROJECT_EXPERIMENT,
	ROVO_SEARCH_COMPARE_RESULTS_PASS_THROUGH_RATE,
	NAV_REFRESH_FREE_CUSTOMERS_EXP,
	NAV_REFRESH_NEW_CUSTOMERS_EXP,
	NAV_REFRESH_NEW_CUSTOMERS_X_EXP,
	METRICS_IMPROVEMENTS_SEQ_EXPERIMENT,
	GRW_2022_VIEW_ALL_APPS_IN_HOME,
	SKIP_SHOW_MORE_PROGRESSIVE,
	PROJECTS_NATIVE_INTEGRATION_WITH_JIRA,
	LOOM_GLOBAL_APPS_NAV_RECOMMENDATION_EXPERIMENT,
	ROVO_CHAT_REFRESH_V1_EXPERIMENT,
	TEAMS_APP_LANDING_APP_PEOPLE_BUTTON_EXPERIMENT,
	TOWNSQUARE_STARRED_FEED,
	HOME_FEEDS_3P_SL_CLICKED_EXPERIMENT,
	TEAM_LENS_IN_ATLASSIAN_HOME_EXPERIMENT,
	PEOPLE_AND_TEAMS_DIRECTORY_UPLIFT_EXPERIMENT,
} as const;

export type ExperimentKeys = keyof typeof experiments;
export type ExperimentNames = (typeof experiments)[ExperimentKeys];
